import { ArticleRows } from "/react4xp/parts/article-rows/article-rows";

export default (props) => <ArticleRows {...props} />
